import React from 'react';
import { motion } from 'framer-motion';
import { Tag, ChevronRight } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import EscanEatScore from './ScanEatScore';

export default function ProductCard({ product, onClick }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            onClick={onClick}
            className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow"
        >
            <div className="flex gap-4">
                {product.image_url ? (
                    <div className="w-20 h-20 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
                        <img 
                            src={product.image_url} 
                            alt={product.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                ) : (
                    <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center flex-shrink-0">
                        <Tag className="w-8 h-8 text-emerald-400" />
                    </div>
                )}

                <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-2">
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-gray-900 truncate">
                                {product.name}
                            </h3>
                            {product.brand && (
                                <p className="text-sm text-gray-500 truncate">
                                    {product.brand}
                                </p>
                            )}
                        </div>
                        <ChevronRight className="w-5 h-5 text-gray-300 flex-shrink-0" />
                    </div>

                    {product.scaneat_score !== undefined ? (
                      <EscanEatScore 
                        score={product.scaneat_score} 
                        trafficLight={product.traffic_light}
                        size="small"
                      />
                    ) : (
                        product.category && (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-md bg-gray-100 text-gray-600 text-xs">
                                {product.category}
                            </span>
                        )
                    )}
                </div>
            </div>

            <div className="mt-3 pt-3 border-t border-gray-50">
                <span className="text-xs text-gray-400">
                    {format(new Date(product.created_date), "d MMM yyyy", { locale: es })}
                </span>
            </div>
        </motion.div>
    );
}